import React from 'react';

const CustomerLoaderRow = () => (
    <>
        <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip">
            <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
        <td className="max-w-px min-w-[240px]">
            <div className="flex items-center gap-2">
                <span className="truncate block max-w-[240px] text-grayLight900 font-semibold leading-[18px] custom-loading">lorem ipsum dolor sit amet</span>
            </div>
        </td>
        <td className="max-w-[9.15%] min-w-[140px]">
            <span className="custom-loading rounded-md">Lorem ipsum </span>
        </td>
        <td className="max-w-px min-w-[210px]">
            <div className="custom-loading w-fit">Lorem ipsum dolor sit lorem</div>
        </td>
        <td className="max-w-[9.15%] min-w-[200px]">
            <p className="custom-loading w-fit">Lorem ipsum dolor sit</p>
        </td>
        <td className="max-w-[9.15%] min-w-[170px]">
            <span className="custom-loading w-fit rounded-md">Lorem ipsum</span>
        </td>
        <td className="w-[64px] min-w-[64px] max-w-[64px] sticky right-0 bg-inherit z-[1] table-cell-with-tooltip">
            <div className="flex items-center justify-end gap-1.5 h-full table-col-tooltip-space-common-xs">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
    </>
);

export default CustomerLoaderRow;
